<template lang="pug">
</template>

<script>
export default {
  name: "BaseForm",
  props: {
    value: Object
  },
  data() {
    return {
      localValue: {...this.value}
    }
  },
  watch: {
    localValue: {
      handler() {
        this.$emit('input', this.localValue)
      },
      deep: true
    },
  },
};
</script>



// WEBPACK FOOTER //
// BaseForm.vue?7535d228